<script>
  import Chart from 'chart.js';
  import {onMount} from "svelte"
  export let xaxis = ""
  export let yaxis = ""
  export let data = []
  export let label = ""
  export let color = "#306e93"
  export let options = {
              scales: {
                xAxes: [{
                  type: 'time',
                    time: {
                      unit: 'month'
                    }
                  }],
                  yAxes: [{
                      ticks: {
                          beginAtZero: true
                      }
                  }]
              }
          }
  let ctx 

  function createChart(){
    console.log({ctx,data,xaxis,yaxis})
    if(ctx){
      const myChart = new Chart(ctx, {
          type: 'bar',
          data: {
              labels: data.map(row => row[xaxis]),
              datasets: [{
                  label: label,
                  data:  data.map(row => row[yaxis]),
                  backgroundColor:color,
                  
                  // backgroundColor: [
                  //     'rgba(255, 99, 132, 0.2)',
                  //     'rgba(54, 162, 235, 0.2)',
                  //     'rgba(255, 206, 86, 0.2)',
                  //     'rgba(75, 192, 192, 0.2)',
                  //     'rgba(153, 102, 255, 0.2)',
                  //     'rgba(255, 159, 64, 0.2)'
                  // ],
                  // borderColor: [
                  //     'rgba(255, 99, 132, 1)',
                  //     'rgba(54, 162, 235, 1)',
                  //     'rgba(255, 206, 86, 1)',
                  //     'rgba(75, 192, 192, 1)',
                  //     'rgba(153, 102, 255, 1)',
                  //     'rgba(255, 159, 64, 1)'
                  // ],
                  borderWidth: 1
              }]
          },
          options: options
      })
    }
  }
  $: createChart(data,xaxis,yaxis)
</script>


<div>
  <canvas bind:this={ctx} />
</div>